module.exports = __webpack_public_path__ + "img/r8.9b233e5b.png";